import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AppSwitcher as BaseAppSwitcher,
  createAgionAppSwitcherApps,
  getCurrentAgionAppId,
  type AgionAppId,
} from '@agion/ui'
import { isPlatformAdmin, useAuth } from '@/shared/auth/unified-auth'

interface AppSwitcherProps {
  collapsed?: boolean
}

export const AppSwitcher: React.FC<AppSwitcherProps> = ({ collapsed = false }) => {
  const { t } = useTranslation('components')
  const { user } = useAuth()

  if (!isPlatformAdmin(user)) return null

  const appLabels: Record<AgionAppId, string> = {
    admin: t('appSwitcher.admin', { defaultValue: 'Admin' }),
    control: t('appSwitcher.control', { defaultValue: 'Control' }),
    app: t('appSwitcher.app', { defaultValue: 'App' }),
    analytics: t('appSwitcher.analytics', { defaultValue: 'Analytics' }),
  }

  return (
    <BaseAppSwitcher
      apps={createAgionAppSwitcherApps(appLabels)}
      currentAppId={getCurrentAgionAppId() ?? undefined}
      variant="sidebar"
      collapsed={collapsed}
      labels={{
        selectApp: t('appSwitcher.selectApp', { defaultValue: 'Select App' }),
        title: t('appSwitcher.title', { defaultValue: 'Applications' }),
        description: t('appSwitcher.description', { defaultValue: 'Switch between Agion applications' }),
        tooltip: t('appSwitcher.tooltip', { defaultValue: 'Switch application' }),
      }}
    />
  )
}
